import Model from "../Model";

class downloadpdfAnalitics extends Model{

    buildUrl() {
        return ['analytics/get_excel'];
    }

    all(config = {}) {
        return this.request({ method: 'GET', action: 'all', ...config });
    }

    create(form) {
        return this.request({
            action: 'store',
            method: 'POST',
            data: form
        });
    }
}


export default new downloadpdfAnalitics;